import type { MissingInformationDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/missingInformation';
import { atom } from 'recoil';
import { getMissingInformationSelector } from '../selectors/getMissingInformationSelector';

export const missingInformationAtom = atom<MissingInformationDTO>({
    key: 'missingInformation',
    default: getMissingInformationSelector
});
